export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
};

export const minMonthFirstQuarter = 1;
export const maxMonthFirstQuarter = 3;
export const minMonthSecondQuarter = 4;
export const maxMonthSecondQuarter = 6;
export const minMonthThirdQuarter = 7;
export const maxMonthThirdQuarter = 9;
export const minMonthFourthQuarter = 10;
export const maxMonthFourthQuarter = 12;

export const passwordRegex = /^(?=.*[!@#$%^&*()_+{}|:<>?~[\]^-])(?=.*[A-Z])(?=.*\d).{8,}$/;
export const APP_LOCAL_MONTH_FORMAT = 'MMMM';
export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATE_FORMAT_PAYLOAD = 'YYYY-MM-DD';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';

export const ObjectiveSymbol = 'O';
export const KeyResultSymbol = 'KR';
export const ActivitySymbol = 'T';

export const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 phút (Hiển thị cảnh báo)
export const CONFIRMATION_TIME = 1 * 60 * 1000; // 1 phút (Chờ phản hồi)
